<script lang="ts">
  import dayjs from "dayjs";
  import { onMount } from "svelte";
  import { headerDisplayStore, loadingStore } from "../stores/General";
  import { navigate } from "svelte-navigator";
  import Button from "../components/button/RouteButton.svelte";
  import { getList, update } from "../api";
  import config from "../assets/config";
  import CustomIcon from "../components/CustomIcon.svelte";
  import NewTable, { Column } from "../components/table/Table.svelte";
  import PublisherListChannels from "./PublisherList_Channels.svelte";
  import ActivateModal from "../components/modal/ActivateModal.svelte";
  import changesStore from "../stores/Changes";
  import GenericButton from "../components/button/GenericButton.svelte";
  import { Exclamation } from 'svelte-hero-icons';

  const module_name = "publisher";
  let showDownloadReportModal = false;
  let publisherId = "";
  let publisherName = "";
  let period = "";
  let selectedMonth = dayjs().format("MM");
  let selectedYear = dayjs().format("YYYY");
  let pageSize = 10;
  let data = [];
  let count = 0;
  let page = 1;
  let sortBy = "name";
  let sortOrder = "ASC";
  let filter = { show_deactivated: false};
  let loading = false;
  let selectedIds = [];
  let selectedPublisherId;
  $: period = `${selectedYear}${selectedMonth}`;
  let showModal = false;
  let modalData: any = {};
  let publisher_types = [];
  let width="110";
  const tableId = "publishers";
  let pagination = { page, pageSize, count };

  onMount(() => {
    headerDisplayStore.SetTitle("Publishers");
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "publisher",
        label: "Publishers",
      },
      {
        key: "list",
        label: "List",
      },
    ]);

    loadData();
  });

  let columns: Column[] = [
    {
      label: "Publisher",
      dataKey: "name",
      sortBy: "name",
      renderBy: "formatter",
      width
    },
    {
      label: "Publisher ID",
      dataKey: "publisher_id",
      sortBy: "publisher_id",
      renderBy: "formatter",
      width
    },
    {
      label: "Publisher Type",
      dataKey: "publisher_type",
      renderBy: "formatter",
      sortBy: "publisher_type",
      formatter: formatPublisherType,
      width
    },
    {
      label: "Max Creative",
      dataKey: "max_creative_duration",
      sortBy: "max_creative_duration",
      renderBy: "formatter",
      width
    },
    {
      renderBy: "actions",
      width: "55",
      actions: [
        { key: "edit", label: "Edit", icon: "edit", type: "button" },
        {
          key: "activate",
          label: "Activate",
          icon: "",
          name: "deactivated",
          type: "submit",
        },
        {
          key: "dlt",
          label: "Delete",
          icon: "dlt",
          type: "button",
          hidden: ((): boolean => {
            // console.log(sessionStorage.getItem("P!ne3_enabled"));
            if (sessionStorage.getItem("P!ne3_enabled")) {
              return false;
            }
            return true;
          })(),
        },
      ],
    },
  ];

  let filters = [
    { label: "Search", key: "search", filter: "text" },
    { label: "Publisher Id", key: "publisher_id", filter: "text" },
    {
      label: "Show Deactivated",
      key: "show_deactivated",
      filter: "boolean",
      default: filter.show_deactivated,
    },
  ];

  function loadData() {
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    pagination = {...pagination, ...mainSettingsArray?.pagination};

    if (pagination !== null){
      pageSize = pagination.pageSize;
      page = pagination.page;
    }

    data = [];
    loadingStore.on(module_name);
    getList(module_name, pageSize, page, sortBy, sortOrder, filter)
      .then(async (response) => {
        await getList(module_name + "/types", pageSize, page, sortBy, sortOrder)
          .then((typeResponse) => {
            publisher_types = typeResponse.data;
          })
          .catch((error) => {
            headerDisplayStore.ShowError({
              title: "Server error",
            });
          });

        data = response.data;
        pagination.count = response.count;
        loadingStore.off(module_name);
      })
      .catch((error) => {
        loadingStore.off(module_name);
        headerDisplayStore.ShowError({
          title: "Server error",
        });
      });
  }

  function formatPublisherType(publisher_id) {
    if (publisher_id === null) return " ";
    return (
      publisher_types.length &&
      (publisher_types.find((type) => type.id === publisher_id)?.name || " ")
    );
  }

  function onToggledTableChange(e) {
    selectedPublisherId = e.detail.publisher_id;
  }

  function download() {
    getList("publisher/sellers", null, null, null, null, {})
      .then(({ data }) => {
        const a = document.createElement("a");
        const file = new Blob([JSON.stringify(data)], {
          type: "text/plain",
        });
        a.href = URL.createObjectURL(file);
        a.download = "sellers.json";
        a.click();
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function editAction(value) {
    navigate(`/publisher/edit/${value.publisher_id || value.id}`);
  }

  function downloadAction(value) {
    publisherId = value.publisher_id;
    publisherName = value.name;
    showDownloadReportModal = true;
  }

  function onPageChange(event) {
    let mainSettingsArray= JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

      mainSettingsArray ={...mainSettingsArray, pagination:event.detail};
      
      localStorage.setItem(
      `_tableMainSettings_${tableId}`,
      JSON.stringify(mainSettingsArray)
    );

    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function onSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function onFilterChange(event) {
    filter = event.detail.filter;
    filter.show_deactivated = !!filter.show_deactivated;
    // reset page number to get first results
    page = 1;

    loadData();
  }

  function handleCheckedChange(event) {
    selectedIds = event.detail.selectedIds;
  }

  function onActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case "edit":
        editAction(row);
        break;
      case "activate":
        ToggleModal(row);
        break;
    }
  }

  function ToggleModal(publisher) {
    //modalData is an object sending all necessary data to the modal
    modalData.publisher_deactivated = publisher.deactivated;
    modalData.publisher_id = publisher.publisher_id;
    modalData.headerText = "Warning";
    modalData.Icon = Exclamation;

    if (publisher.deactivated == true) {
      modalData.body = "Are you sure you want to activate the publisher?";
      modalData.rightButtonText = "Activate";
      modalData.rightButtonType = "success-solid";
    } else {
      modalData.body = "Are you sure you want to deactivate the publisher?";
      modalData.rightButtonText = "Deactivate";
      modalData.rightButtonType = "danger-solid";
    }
    showModal = !showModal;
  }

  function ToggleActivate() {
    let data: any = {};

    data.deactivated = !modalData.publisher_deactivated;
    data.publisher_id = modalData.publisher_id;

    update(module_name, data)
      .then((response) => {
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Publisher saved successfully",
          });
          loadData();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function onCancel() {
    changesStore.remove();
    navigate("/publisher");
  }
</script>

<div class="flex flex-col h-full">
  <div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
      <div class="sm:flex items-center justify-between">
        <div>
          <!-- <button
                      type="button"
                      on:click={() => {
                          publisherEditStore.set(null);
                          navigate('/publisher/edit');
                      }}
                      class="inline-flex sm:ml-3 mt-4 sm:mt-0 items-start justify-start px-6 py-3 bg-yellow-500 hover:bg-yellow-600 focus:outline-none rounded"
                  >
                      <p class="text-sm font-medium leading-none text-white">
                          New Publisher
                      </p>
                  </button> -->
        </div>
        <div>
          <div
            class="flex justify-center z-0 shadow-sm rounded-md sm:shadow-none sm:space-x-6"
          >
            <Button name="New Publisher" route="/publisher/new" />
            <button
              type="button"
              on:click={() => {
                download();
              }}
              class="w-48 h-10 relative inline-flex items-center justify-center px-4 py-1 rounded-md border shadow-nv border-custom-orange text-sm font-medium text-custom-orange hover:bg-custom-orange hover:text-custom-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
            >
              <span> Export Json</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <Table
          id="publishers"
          {columns}
          {filters}
          bind:data
          {count}
          {pageSize}
          {page}
          {sortBy}
          {sortOrder}
          on:pageChange={onPageChange}
          on:sortChange={onSortChange}
          on:onFilterChange={onFilterChange}        /> -->

    <NewTable
      bind:data
      {columns}
      defaultConfig={{
        tableId,
        stickyHeader: true,
        stickyFirstColumn: true,
        stickyLastColumn: true,
        multilineColumns: false,
        showCheckboxes: false,
        enableDeleteAll: false,
        enableSubTables: true,
      }}
      dataKey="publisher_id"
      {filters}
      loader={$loadingStore.loading}
      {pagination}
      {selectedIds}
      sorting={{ sortBy, sortOrder }}
      on:actionClick={onActionClick}
      on:checkedChange={handleCheckedChange}
      on:filterChange={onFilterChange}
      on:pageChange={onPageChange}
      on:sortClick={onSortChange}
      on:subTableIdChange={onToggledTableChange}
    >
      <PublisherListChannels
        slot="sub_table"
        publisher_id={selectedPublisherId}
      />
    </NewTable>
  </div>

  {#if showDownloadReportModal}
    <div
      class="py-12  bg-gray-300 transition duration-150 ease-in-out z-10 fixed overflow-auto top-0 right-0 bottom-0 left-0"
      id="report-modal"
    >
      <div
        role="alert"
        class="container mx-auto w-11/12 md:w-2/3 max-w-lg flex justify-center"
      >
        <div class="flex items-center justify-center py-8 px-4">
          <div class="relative md:w-96 rounded shadow-lg p-4  bg-white">
            <h1
              class="text-lg pb-3 font-bold leading-none  text-gray-800 pt-6 text-center"
            >
              Download Report
            </h1>
            <div class="text-center py-3">
              Publisher: {publisherName} ({publisherId})
            </div>
            <div class="text-center py-3">
              <input
                type="number"
                bind:value={selectedYear}
                class="max-w-lg inline-block w-36 shadow-sm focus:ring-yellow-500 focus:border-yellow-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div class="text-center py-3">
              <select
                bind:value={selectedMonth}
                class="max-w-lg w-36 inline-block focus:ring-yellow-500 focus:border-yellow-500 shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
              >
                <option value="01">January</option>
                <option value="02">February</option>
                <option value="03">March</option>
                <option value="04">April</option>
                <option value="05">May</option>
                <option value="06">June</option>
                <option value="07">July</option>
                <option value="08">August</option>
                <option value="09">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </div>
            <div class="px-2 pt-6 text-center">
              <a
                href={`${config.base_url}/report/publisher/monthly?pub=${publisherId}&month=${period}`}
                target="_blank"
                rel="noreferrer"
                on:click={() => {
                  showDownloadReportModal = false;
                }}
                class="text-sm inline-block font-semibold leading-6 bg-yellow-500 rounded py-2 px-4 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-700 text-white"
              >
                Download
              </a>
            </div>
            <button
              aria-label="close report-modal"
              class="cursor-pointer absolute top-0 right-0 mt-0.5 mr-0.5  text-gray-400 hover:  text-gray-600 transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-600"
              on:click={() => {
                showDownloadReportModal = false;
              }}
            >
              <CustomIcon
                width="20"
                height="20"
                name="download_pub"
                color="gray"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>
{#if showModal}
  <ActivateModal
    on:click={ToggleModal}
    on:reload={loadData}
    {modalData}
    on:modalSubmit={ToggleActivate}
  />
{/if}
